import { Ellipsis } from '@zoom/components';
import clsx from 'clsx';
import React from 'react';

type RadioButtonProps = {
  checked?: boolean;
  children: React.ReactNode;
  className?: string;
  testId?: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
};

export const RadioButton: React.FC<RadioButtonProps> = ({
  checked = false,
  children,
  className,
  testId,
  name,
  onChange,
  value,
}) => (
  // See https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/issues/633
  // Rule doesn't work correctly with nested input and `nesting` or `either` rule setting
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  <label className={clsx('radio-button', className)} data-test-id={testId}>
    <input
      checked={checked}
      className="radio-button__input sr-only"
      name={name}
      onChange={onChange}
      type="radio"
      value={value}
    />
    <span className="radio-button__indicator" aria-hidden="true" />
    {/* @ts-expect-error: Incompatible type of FC from React < v18 */}
    <Ellipsis>{children}</Ellipsis>
  </label>
);
